import datos from "src/services/datos";
import esArray from "src/general_components/functionEsArray";
import Swal from "sweetalert2";
import "src/services/styles/sweetAlert.css";

export const getTablaEstructura = async (model) => {
    const tablaEstructura = new datos(model);

    const data = {
        "model": model
    }
    const response = await tablaEstructura.getTableStructure(data);
    return response;
};


export const getDataSelect = async (modelo,condicion = false) => {
    const object = new datos(modelo);
    object.addCondition(modelo, "id", 0, ">");
    
    console.log("condicion", condicion);
    
    if (Array.isArray(condicion) && condicion.length > 0) {

        const condiciones_combinadas = agruparCondiciones(condicion);
        console.log("condiciones_combinadas", condiciones_combinadas)
        condiciones_combinadas.forEach(cond => {
            object.addCondition(modelo, cond.campo, cond.valor, cond.operador);
        });
    }
    
    try {
        const response = await object.get();
        const arrResponse = esArray(response?.wsResponse?.[modelo]);
        return arrResponse || [];
    } catch (error) {
        console.error('Error en getDataSelect:', error);
        return [];
    }
};

export const getDataWhereId = async (modelo, colum, id) => {
    const palabraExtraida = colum.replace('id_', ''); // Cortar "id_"

    const columna = modelo !== palabraExtraida ? colum : "id";
    const object = new datos(modelo);
    object.addCondition(modelo, columna, id, "=");

    try {
        const response = await object.get();
        const arrResponse = response?.wsResponse?.[modelo];
        return arrResponse;
    } catch (error) {
        console.error('Error en getDataSelect:', error);
        return false;
    }
};


export const getPaginatedData = async (limit, offset, filtros) => {
    const { modelo, condiciones, joins } = filtros;
    const datosModelo = new datos(modelo);
    datosModelo.addCondition(modelo, "id", 0, ">");

    if(joins){
        // Agregar condiciones dinámicamente
        joins.forEach(join => {
            datosModelo.join(join.modelo, join.id_relacion, join.id, join.operador);
        });
        // prd_orden_produccion.join("prd_equipos", "id_prd_orden_produccion", "id", "=");
    }

    if (condiciones) {
    condiciones.forEach(condicion => {
        let { propiedad, valor, operador } = condicion;

        // Normalizar operador
        operador = operador?.toUpperCase() || "=";

        // LIKE → envolver con %
        if (operador === "LIKE") {
            valor = `%${valor}%`;
        }

        // Si es string → comillas
        if (typeof valor === "string") {
            valor = `'${valor.replace(/'/g, "''")}'`;
        }

        datosModelo.addCondition(
            modelo,
            propiedad,
            valor,
            operador
        );
    });
}


    if (limit) {
        datosModelo.addLimitCondition(limit, offset);
    }

    datosModelo.addOrderCondition(modelo, "id", "ASC");

    const response = await datosModelo.get();
    let data = esArray(response.wsResponse[modelo]);

    // Agregar columnas adicionales
    data = data.map(item => ({
        ...item,
        columna_extra_1: true,
        columna_extra_2: true,
        columna_extra_3: true
    }));

    let result = {
        data: [],
        total_records: 0,
    };
    const transformedData = data.map(item => {
        // Recorre cada propiedad del objeto
        for (let key in item) {
            if (typeof item[key] === 'object' && Object.keys(item[key]).length === 0) {
                item[key] = ""; // Reemplaza el objeto vacío por una cadena vacía
            }
        }
        return item;
    });

    const datos_mapeados = mapearDescripcion(transformedData);
    if (!response.wsResponse.empty) {
        result = {
            data: datos_mapeados,
            total_records: response.wsResponse.total_records,
        };
    }
    return result;
};




export const getDataByCondition = async (modelo) => {
    const datosModelo = new datos(modelo);
    datosModelo.addCondition(modelo, "id", 0, ">");
    const response = await datosModelo.get();
    return esArray(response.wsResponse[modelo]);
};

export const deleteDataById = async (id, params, idElementData) => {
    const { modelo } = idElementData;
    let status = false;
    await Swal.fire({
        title: `¿Está seguro de que desea eliminar este ${modelo}?`,
        text: "¡Si sigue adelante, no se podrán revertir los cambios!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, quiero eliminarlo!",
        cancelButtonText: "No, no estoy seguro!",
        customClass: {
            container: 'my-swal-delete'
        },
    }).then(async (result) => {
        if (result.isConfirmed) {
            const modelData = new datos(modelo);
            const data = { id: id };
            const response = await modelData.delete(data);

            if (response.status === "true") {
                status = true;
                await Swal.fire({
                    title: "¡Eliminado!",
                    text: `El ${modelo} ha sido eliminado exitosamente.`,
                    icon: "success",
                    customClass: {
                        container: 'my-swal-delete'
                    }
                });

            } else {
                await Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: response.message,
                    customClass: {
                        container: 'my-swal-delete'
                    }
                });
            }
        }
    });
    return status;
};

function agruparCondiciones(condiciones) {
    const agrupado = {};

    condiciones.forEach(({ campo, valor }) => {
        if (!agrupado[campo]) {
            agrupado[campo] = [];
        }
        agrupado[campo].push(valor);
    });

    return Object.keys(agrupado).map(campo => ({
        campo,
        valor: agrupado[campo].join(','),
        operador: "in"
    }));
}

function mapearDescripcion(data) {
    return data.map(item => {
        const nuevoItem = { ...item };

        Object.keys(item).forEach(key => {
            if (key.startsWith("id_")) {
                const relationKey = key.replace("id_", ""); // Buscar en relations sin "id_"
                if (item.relations && item.relations[relationKey]) {
                    const relationData = item.relations[relationKey];

                    // Buscar primero "descripcion", si no existe buscar "detalle"
                    const descripcion = relationData.descripcion || relationData.detalle;
                    if (descripcion) {
                        nuevoItem[relationKey] = descripcion;
                    }
                }
            }
        });

        return nuevoItem;
    });
}